import {Component, Input, SimpleChanges} from '@angular/core';
import {OrderedItem} from "../interface/ordered-item";
import {OrderwiseWorkflow} from "../interface/orderwise-workflow";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {AddOrderTransmissionService} from "../../raintree/transmission/order-transmission/order-transmission.service";
import {ConfigurationService} from "../../services/configuration.service";
import {CustomSize} from "../../cart/interface/custom-size";
import {SelectedFinishProfileItem} from "../interface/selected-finish-profile-item";
import {CreateReviewDialogComponent} from "../../review/create-review-dialog/create-review-dialog.component";
import {OrderwiseWorkflowSubprocess} from "../interface/orderwise-workflow-subprocess";
import {CustomOrderItem} from "../interface/custom-order-item";

@Component({
	selector: 'fb-custom-order-item',
	templateUrl: './custom-order-item.component.html',
	styleUrls: ['./custom-order-item.component.scss']
})
export class CustomOrderItemComponent {

	@Input() orderItemId: number = 0;
	@Input() orderId: number = 0;
	@Input() product: CustomOrderItem = {} as CustomOrderItem;
	public showProcess: boolean = false;
	public loading: boolean = false;
	public orderItemWorkflow: OrderwiseWorkflow = {} as OrderwiseWorkflow;

	constructor(
		private _router: Router,
		private _dialog: MatDialog,
		private _orderApi: AddOrderTransmissionService
	) {
	}

	private _getOrderWorkflow(): void {
		this._orderApi.orderItemProgressGetById(
			ConfigurationService.SERVER_ENDPOINT + `/get/custom-order/${this.orderId}/workflow/${this.product.id}`,
			()=> {
				this.loading = true;
			},
			()=> {},
			(response)=> {
				this.orderItemWorkflow = response;
				this.orderItemWorkflow.steps = this.orderItemWorkflow.steps.sort((a, b) => (a.previousStepElementId > b.previousStepElementId ? 1 : -1));

				this.orderItemWorkflow.steps.forEach(step => {
					if (step.subProcesses && step.subProcesses.length > 1) {
						step.subProcesses = this.sortSubProcesses(step.subProcesses);
					}
				});
				this.loading = false;
			},
			()=> {},
			()=> {}
		)
	}

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(this.product.id && this.product.hasWorkflow) {
			this._getOrderWorkflow();
		}
	}

	public navigate(
		orderedItem: CustomOrderItem,
	): void {

		let slug = orderedItem.customization.fabricProductPreview ? 'fabric-product/' + orderedItem.customization.fabricProductPreview.product.slug :
			'';

		if(orderedItem.customization.fabricProductPreview)
			this._router.navigate(['../../product/' + slug])
	}

	public prepareCustomSizeLabel(customSizeData: CustomSize): string {

		let listOfLabel: string[] = [];
		let label: string = '';

		for (const [key, value] of Object.entries(customSizeData)) {
			// console.log(key, value);
			listOfLabel.push(`${key}: ${value}`);
		}

		label = listOfLabel.join();

		return label;
	}

	public prepareFinishLabel(selectedFinishItems: SelectedFinishProfileItem[]): string {

		let listOfLabel: string[] = [];
		let label: string = '';

		selectedFinishItems.forEach((selectedFinishItems: SelectedFinishProfileItem) => {
			listOfLabel.push(selectedFinishItems.label);
		});

		label = listOfLabel.join();

		return label
	}

	public sortSubProcesses(subProcesses: OrderwiseWorkflowSubprocess[]): OrderwiseWorkflowSubprocess[] {
		const sorted: OrderwiseWorkflowSubprocess[] = [];
		const subProcessMap = new Map();

		subProcesses.forEach(sp => {
			subProcessMap.set(sp.subProcessElementId, sp);
		});

		let current = subProcesses.find(sp => !sp.previousSubProcessElementId);

		while (current) {
			sorted.push(current);
			current = subProcessMap.get(current.nextSubProcessElementId);
		}

		return sorted;
	}

	public onViewProcessUpdates($event: boolean): void {
		this.showProcess = $event;
	}
}
